const NAV_MAPPER = {
  new_journey_page: {
    name: 'booking-new',
    icon: 'plus-square',
    text: 'New Journey',
  },
  booked_journey_page: {
    name: 'bookings-index',
    icon: 'history',
    text: 'Booked Journeys',
  },
  unconfirmed_bookings_page: {
    name: 'bookings-unconfirmed',
    icon: 'calendar',
    text: 'Unconfirmed Bookings',
  },
  dashboard_page: {
    name: 'dashboard-index',
    icon: 'columns',
    text: 'Dashboard',
  },
  reports_page: {
    name: 'reports-index',
    icon: 'chart-bar',
    text: 'Reports',
  },
  staff_member_page: {
    name: 'users-index',
    text: 'Staff members',
  },
  train_station_page: {
    name: 'stations-index',
    text: 'Train Station',
  },
  passenger_page: {
    name: 'passengers-index',
    text: 'Passengers',
  },
  statistics_page: {
    name: 'statistics-index',
    text: 'Statistics',
  },
  events_page: {
    name: 'events-index',
    text: 'Events',
  },
  access_control_page: {
    name: 'access_control',
    text: 'Access Control',
  },
}

export default NAV_MAPPER
